import { initializeApollo } from 'gql/client'
import React from 'react'
import { PAGINA } from 'utils/queries'
import { useRouter } from 'next/router'
import RecuperaPasswordTemplate from '@components/templates/RecuperaPasswordTemplate/RecuperaPasswordTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const RecuperoPasswordPartoRiparto = ({ pagina }) => {
  const router = useRouter()
  const from = router.query.f && decodeURIComponent(router?.query?.f?.toString())
  return <RecuperaPasswordTemplate pagina={pagina} iframe from={from} />
}

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'recupera-password' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
    revalidate: 60 * 2, // In seconds
  }
}, '/recupera-password-parto-riparto')

export default RecuperoPasswordPartoRiparto
